import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Params, QueryParamsHandling, RouterLink } from '@angular/router';

@Component({
    selector: 'big-service-tools-diagnosis-code-search-item-table-cell-links',
    templateUrl: './diagnosis-code-search-item-table-cell-links.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'flex flex-wrap max-w-full',
    },
    imports: [RouterLink],
})
export class DiagnosisCodeSearchItemTableCellLinksComponent {
    public readonly links = input.required<
        {
            title: string;
            routerLink: (string | number)[];
            queryParams: Params | null;
            queryParamsHandling: QueryParamsHandling;
        }[]
    >();
}
